import React from 'react';
import { useAuth } from '../context/AuthContext';
import PageHero from '../components/common/PageHero';
import { Card, CardContent } from '../components/ui/card';
import { 
  MessageSquare, 
  FileText, 
  BookOpen, 
  DollarSign, 
  CheckSquare, 
  BarChart3 
} from 'lucide-react';

const ExecutiveMembers = () => {
  const { user } = useAuth();

  const executiveCards = [
    {
      id: 1,
      title: 'Meeting Request',
      icon: MessageSquare,
      link: '/executive/meeting-request',
      description: 'Request or schedule executive meetings'
    },
    {
      id: 2,
      title: 'Meeting Minutes',
      icon: FileText,
      link: '/executive/meeting-minutes',
      description: 'View and manage meeting minutes'
    },
    {
      id: 3,
      title: 'Management Guide',
      icon: BookOpen,
      link: '/executive/management-guide',
      description: 'Executive management resources and guides'
    },
    {
      id: 4,
      title: 'Financials',
      icon: DollarSign,
      link: '/executive/financials',
      description: 'Financial reports and statements'
    },
    {
      id: 5,
      title: 'Tasks',
      icon: CheckSquare,
      link: '/executive/tasks',
      description: 'Executive tasks and action items'
    },
    {
      id: 6,
      title: 'Reports',
      icon: BarChart3,
      link: '/executive/reports',
      description: 'Generate and view executive reports'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section - Navy Background */}
      <div className="bg-[#2c3e7d] text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold uppercase tracking-wide">
            EXECUTIVE MEMBER
          </h1>
          <div className="w-24 h-1 bg-white mx-auto mt-4"></div>
        </div>
      </div>
      
      <div className="container mx-auto px-4 py-12">
        {/* Executive Cards Grid - 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {executiveCards.map((card) => {
            const IconComponent = card.icon;
            return (
              <Card 
                key={card.id} 
                className="hover:shadow-xl transition-all duration-300 cursor-pointer group bg-white border-none"
                onClick={() => window.location.href = card.link}
              >
                <CardContent className="p-8 flex flex-col items-center text-center">
                  <div className="w-20 h-20 bg-gray-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#2c3e7d] transition-colors">
                    <IconComponent size={40} className="text-[#2c3e7d] group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {card.title}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {card.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Info Message */}
        <div className="mt-12 max-w-3xl mx-auto">
          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg className="h-6 w-6 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-blue-800">Executive Member Access</h3>
                <div className="mt-2 text-sm text-blue-700">
                  <p>
                    This area is exclusive to Executive Committee members. Use the tools above to manage meetings, 
                    review financials, track tasks, and access executive resources.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExecutiveMembers;